<template>
  <b-modal id="modal-fail" hide-footer centered>
    <div class="col-12 d-flex flex-column align-items-center modalsTables">
      <img
        class="centerImg1"
        src="@/assets/images/icons/close.svg"
        width="20%"
      />
      <h3 class="pt-5 font-weight-bold">¡Proceso fallido!</h3>
      <p class="pt-5">{{ messageModal }}</p>
      <button
        class="mt-5 mb-5 col-6 btn btn-danger p-2"
        style="font-size: 16px;"
        @click="$bvModal.hide('modal-fail')"
      >
        Entendido
      </button>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    messageModal: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped></style>
